import { Component, inject } from '@angular/core';
import { LucideAngularModule, Check, ArrowRight } from 'lucide-angular';
import { ModalService } from '../services/modal.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [LucideAngularModule, TranslateModule],
  template: `
    <section id="pricing" class="py-20 md:py-28 bg-dark-200 relative overflow-hidden">
      <div class="max-w-7xl mx-auto px-5 md:px-10">
        
        <div class="text-center mb-14" data-aos="fade-up">
          <p class="text-primary font-bold text-xs tracking-[0.2em] uppercase mb-3">{{ 'PRICING.LABEL' | translate }}</p>
          <h2 class="text-3xl md:text-[2.75rem] font-black mb-4">{{ 'PRICING.TITLE' | translate }}</h2>
          <p class="text-base text-gray-450 max-w-lg mx-auto">{{ 'PRICING.DESC' | translate }}</p>
        </div>

        <div class="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
          
          <!-- Free -->
          <div class="bg-dark-300 border border-white/[0.06] rounded-2xl p-7" data-aos="fade-up" data-aos-delay="100">
            <p class="text-xs font-bold text-gray-550 tracking-[0.15em] uppercase mb-2">{{ 'PRICING.FREE_TITLE' | translate }}</p>
            <p class="text-4xl font-black text-white mb-1">$0</p>
            <p class="text-gray-550 text-xs mb-8">{{ 'PRICING.FREE_DESC' | translate }}</p>
            
            <div class="space-y-3 mb-8">
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.FREE_ITEM_1' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.FREE_ITEM_2' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.FREE_ITEM_3' | translate }}
              </div>
            </div>
            
            <button (click)="modalService.openComingSoon($event)" class="w-full py-3 rounded-full border border-gray-750 text-white text-sm font-bold hover:border-gray-550 hover:bg-white/[0.02] transition-all">
              {{ 'PRICING.FREE_BTN' | translate }}
            </button>
          </div>

          <!-- Premium -->
          <div class="bg-dark-300 border border-primary/30 rounded-2xl p-7 relative" data-aos="fade-up" data-aos-delay="200">
            <div class="absolute -top-2.5 right-6 bg-primary text-white text-[10px] font-black px-2.5 py-0.5 rounded-full">{{ 'PRICING.PREMIUM_TAG' | translate }}</div>
            
            <p class="text-xs font-bold text-primary tracking-[0.15em] uppercase mb-2">{{ 'PRICING.PREMIUM_TITLE' | translate }}</p>
            <p class="text-4xl font-black text-white mb-1">Custom</p>
            <p class="text-gray-550 text-xs mb-8">{{ 'PRICING.PREMIUM_DESC' | translate }}</p>
            
            <div class="space-y-3 mb-8">
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.PREMIUM_ITEM_1' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.PREMIUM_ITEM_2' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.PREMIUM_ITEM_3' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.PREMIUM_ITEM_4' | translate }}
              </div>
              <div class="flex items-center gap-2.5 text-sm text-gray-350">
                <lucide-icon [img]="Check" class="w-3.5 h-3.5 text-primary flex-shrink-0"></lucide-icon>
                {{ 'PRICING.PREMIUM_ITEM_5' | translate }}
              </div>
            </div>
            
            <button (click)="modalService.openComingSoon($event)" class="w-full py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-primary-dark transition-colors flex items-center justify-center gap-2">
              {{ 'PRICING.PREMIUM_BTN' | translate }}
              <lucide-icon [img]="ArrowRight" class="w-3.5 h-3.5"></lucide-icon>
            </button>
          </div>

        </div>
      </div>
    </section>
  `
})
export class PricingComponent {
  modalService = inject(ModalService);
  readonly Check = Check;
  readonly ArrowRight = ArrowRight;
}
